module.exports = __webpack_public_path__ + "img/activities.d13a49cf.png";